import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getByIdMasterSkripsi = createAsyncThunk("skripsi/getByIdMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const getByIdMasterSkripsiTipe = createAsyncThunk("skripsi/getByIdMasterSkripsiTipe",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const getByIdMasterSkripsiPembimbing = createAsyncThunk("skripsi/getByIdMasterSkripsiPembimbing",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findAllMasterSkripsi = createAsyncThunk("skripsi/findAllMasterSkripsi",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findAllMasterSkripsiPembimbing = createAsyncThunk("skripsi/findAllMasterSkripsiPembimbing",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const findAllMasterSkripsiTipe = createAsyncThunk("skripsi/findAllMasterSkripsiTipe",
    async () => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const removeDataMasterSkripsi = createAsyncThunk("skripsi/removeDataMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const removeDataMasterSkripsiPembimbing = createAsyncThunk("skripsi/removeDataMasterSkripsiPembimbing",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const removeDataMasterSkripsiTipe = createAsyncThunk("skripsi/removeDataMasterSkripsiTipe",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/${val}`
            const response = await jwtAuthAxios.delete(url)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const addDataMasterSkripsi = createAsyncThunk("skripsi/addDataMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findMasterSkripsiTipeByMtrIdAndTipe = createAsyncThunk("skripsi/findMasterSkripsiTipeByMtrIdAndTipe",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/tipe/mtr`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });


export const findParamMasterSkripsi = createAsyncThunk("skripsi/findParamMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/param`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findParam2MasterSkripsi = createAsyncThunk("skripsi/findParam2MasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/param2`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const findByNimMasterSkripsi = createAsyncThunk("skripsi/findByNimMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/nim`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const addDataMasterSkripsiPembimbing = createAsyncThunk("skripsi/addDataMasterSkripsiPembimbing",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const addDataMasterSkripsiTipe = createAsyncThunk("skripsi/addDataMasterSkripsiTipe",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/tipe/daftar`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const daftarMasterSkripsi = createAsyncThunk("skripsi/daftarMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi/daftar`
            const response = await jwtAuthAxios.post(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

export const updateDataMasterSkripsi = createAsyncThunk("skripsi/updateDataMasterSkripsi",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const updateDataMasterSkripsiPembimbing = createAsyncThunk("skripsi/updateDataMasterSkripsiPembimbing",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/skripsi`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });
export const updateDataMasterSkripsiTipe = createAsyncThunk("skripsi/updateDataMasterSkripsiTipe",
    async (val) => {
        try {
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/master/tipe`
            const response = await jwtAuthAxios.put(url, val)
            return response.data
        } catch (response) {
            throw response
        }
    });

const initialState = {
    loading: false,
    masterSkripsi:{},
    masterSkripsiList: [],
    masterSkripsiPembimbing:{},
    masterSkripsiPembimbingList: [],
    masterSkripsiTipe:{},
    masterSkripsiTipeList: [],
}

const skripsiSlice = createSlice({
    name: "skripsi",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(findMasterSkripsiTipeByMtrIdAndTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(findMasterSkripsiTipeByMtrIdAndTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipeList = action.payload;
                state.loading = false;
            })
            .addCase(findMasterSkripsiTipeByMtrIdAndTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(daftarMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(daftarMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsi = action.payload;
                state.loading = false;
            })
            .addCase(daftarMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findAllMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(findAllMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsiList = action.payload;
                state.loading = false;
            })
            .addCase(findAllMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findAllMasterSkripsiPembimbing.pending, (state) => {
                state.loading = true;
            })
            .addCase(findAllMasterSkripsiPembimbing.fulfilled, (state, action) => {
                state.masterSkripsiPembimbingList = action.payload;
                state.loading = false;
            })
            .addCase(findAllMasterSkripsiPembimbing.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(findAllMasterSkripsiTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(findAllMasterSkripsiTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipeList = action.payload;
                state.loading = false;
            })
            .addCase(findAllMasterSkripsiTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(addDataMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(addDataMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsi = action.payload;
                state.loading = false;
            })
            .addCase(addDataMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(addDataMasterSkripsiPembimbing.pending, (state) => {
                state.loading = true;
            })
            .addCase(addDataMasterSkripsiPembimbing.fulfilled, (state, action) => {
                state.masterSkripsiPembimbing = action.payload;
                state.loading = false;
            })
            .addCase(addDataMasterSkripsiPembimbing.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(addDataMasterSkripsiTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(addDataMasterSkripsiTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipe = action.payload;
                state.loading = false;
            })
            .addCase(addDataMasterSkripsiTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(updateDataMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateDataMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsi = action.payload;
                state.loading = false;
            })
            .addCase(updateDataMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(updateDataMasterSkripsiPembimbing.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateDataMasterSkripsiPembimbing.fulfilled, (state, action) => {
                state.masterSkripsiPembimbing = action.payload;
                state.loading = false;
            })
            .addCase(updateDataMasterSkripsiPembimbing.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(updateDataMasterSkripsiTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateDataMasterSkripsiTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipe = action.payload;
                state.loading = false;
            })
            .addCase(updateDataMasterSkripsiTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(getByIdMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(getByIdMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsi = action.payload;
                state.loading = false;
            })
            .addCase(getByIdMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(getByIdMasterSkripsiPembimbing.pending, (state) => {
                state.loading = true;
            })
            .addCase(getByIdMasterSkripsiPembimbing.fulfilled, (state, action) => {
                state.masterSkripsiPembimbing = action.payload;
                state.loading = false;
            })
            .addCase(getByIdMasterSkripsiPembimbing.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(getByIdMasterSkripsiTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(getByIdMasterSkripsiTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipe = action.payload;
                state.loading = false;
            })
            .addCase(getByIdMasterSkripsiTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(removeDataMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeDataMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsi = action.payload;
                state.loading = false;
            })
            .addCase(removeDataMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(removeDataMasterSkripsiPembimbing.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeDataMasterSkripsiPembimbing.fulfilled, (state, action) => {
                state.masterSkripsiPembimbing = action.payload;
                state.loading = false;
            })
            .addCase(removeDataMasterSkripsiPembimbing.rejected, (state, action) => {
                state.loading = false;
            })
        builder
            .addCase(removeDataMasterSkripsiTipe.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeDataMasterSkripsiTipe.fulfilled, (state, action) => {
                state.masterSkripsiTipe = action.payload;
                state.loading = false;
            })
            .addCase(removeDataMasterSkripsiTipe.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(findParamMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(findParamMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsiList = action.payload;
                state.loading = false;
            })
            .addCase(findParamMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(findParam2MasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(findParam2MasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsiList = action.payload;
                state.loading = false;
            })
            .addCase(findParam2MasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })

        builder
            .addCase(findByNimMasterSkripsi.pending, (state) => {
                state.loading = true;
            })
            .addCase(findByNimMasterSkripsi.fulfilled, (state, action) => {
                state.masterSkripsiList = action.payload;
                state.loading = false;
            })
            .addCase(findByNimMasterSkripsi.rejected, (state, action) => {
                state.loading = false;
            })
        ;
    }
})
export const skripsiSelectors = (state) => state.skripsi;
export default skripsiSlice.reducer;